import whyContent from './whyContent';
import {
  RegionStaticDataType,
  AERegions,
  AURegions,
  CARegions,
  DERegions,
  GlobalRegions,
  IDRegions,
  IERegions,
  INRegions,
  KYRegions,
  NZRegions,
  PHRegions,
  SGRegions,
  UKRegions,
  ZARegions,
} from './regions';

export { whyContent };
export const countryStaticData = () => {
  const countryData = {
    countryCode: '',
    regions: {} as RegionStaticDataType,
  };
  switch (+process.env.NEXT_PUBLIC_SITE_ID) {
    case 1:
      countryData.countryCode = 'NZ';
      countryData.regions = NZRegions;
      break;
    case 2:
      countryData.countryCode = 'AU';
      countryData.regions = AURegions;
      break;
    case 3:
      countryData.countryCode = 'AE';
      countryData.regions = AERegions;
      break;
    case 4:
      countryData.countryCode = 'CA';
      countryData.regions = CARegions;
      break;
    case 7:
      countryData.countryCode = 'DE';
      countryData.regions = DERegions;
      break;
    case 8:
      countryData.countryCode = 'UK';
      countryData.regions = UKRegions;
      break;
    case 9:
      countryData.countryCode = 'IN';
      countryData.regions = INRegions;
      break;
    case 10:
      countryData.countryCode = 'ZA';
      countryData.regions = ZARegions;
      break;
    case 11:
      countryData.countryCode = 'IE';
      countryData.regions = IERegions;
      break;
    case 12:
      countryData.countryCode = 'ID';
      countryData.regions = IDRegions;
      break;
    case 13:
      countryData.countryCode = 'SG';
      countryData.regions = SGRegions;
      break;
    case 14:
      countryData.countryCode = 'GLOBAL';
      countryData.regions = GlobalRegions;
      break;
    case 15:
      countryData.countryCode = 'PH';
      countryData.regions = PHRegions;
      break;
    case 17:
      countryData.countryCode = 'KY';
      countryData.regions = KYRegions;
      break;
    default:
      countryData.countryCode = 'NZ';
      countryData.regions = NZRegions;
  }
  return countryData;
};

export const isMinorSite = (function minorSite() {
  return [3, 7, 9, 10, 13, 14, 15, 17].indexOf(+process.env.NEXT_PUBLIC_SITE_ID) !== -1;
})();

export const isGlobalSite = (function globalSite() {
  return +process.env.NEXT_PUBLIC_SITE_ID === 14;
})();

/**
 * Handle various hardcoded data for our sites
 * @returns {{signupUrl: string, infopackUrl: string}}
 */
export const staticData = (function getCountryData() {
  const countryStaticContent = countryStaticData();
  const data = {
    infopackUrl: 'https://resources.firsttable.com/global/download-the-first-table-info-pack',
    signupUrl: 'https://resources.firsttable.com/global/sign-up-your-restaurant',
    schedulerLink: 'https://resources.firsttable.com/global/book-a-meeting-with-your-local-rep',
    ...countryStaticContent,
  };
  switch (+process.env.NEXT_PUBLIC_SITE_ID) {
    case 1:
      data.infopackUrl =
        'https://resources.firsttable.com/global/download-the-first-table-info-pack?contact_country=New%20Zealand';
      data.signupUrl =
        'https://resources.firsttable.com/global/sign-up-your-restaurant?contact_country=New%20Zealand';
      break;
    case 2:
      data.infopackUrl =
        'https://resources.firsttable.com/global/download-the-first-table-info-pack?contact_country=Australia';
      data.signupUrl =
        'https://resources.firsttable.com/global/sign-up-your-restaurant?contact_country=Australia';
      break;
    case 4:
      data.infopackUrl =
        'https://resources.firsttable.com/global/download-the-first-table-info-pack?contact_country=Canada';
      data.signupUrl =
        'https://resources.firsttable.com/global/sign-up-your-restaurant?contact_country=Canada';
      break;
    case 8:
      data.infopackUrl =
        'https://resources.firsttable.com/global/download-the-first-table-info-pack?contact_country=United%20Kingdom';
      data.signupUrl =
        'https://resources.firsttable.com/global/sign-up-your-restaurant?contact_country=United%20Kingdom';
      break;
    case 11:
      data.infopackUrl =
        'https://resources.firsttable.com/global/download-the-first-table-info-pack?contact_country=Ireland';
      data.signupUrl =
        'https://resources.firsttable.com/global/sign-up-your-restaurant?contact_country=Ireland';
      break;
    case 12:
      data.infopackUrl =
        'https://resources.firsttable.com/global/download-the-first-table-info-pack?contact_country=Indonesia';
      data.signupUrl =
        'https://resources.firsttable.com/global/sign-up-your-restaurant?contact_country=Indonesia';
      break;
    case 17:
      data.signupUrl =
        'https://resources.firsttable.com/global/sign-up-your-restaurant?contact_country=Caymans';
      break;
    default:
  }
  return data;
})();
